import { takeEvery, put, call} from "redux-saga/effects"
import {GET_HIRE_DECISION_LIST} from './actionType'
import {getInterviewCandidateList} from "../../../../helpers/fakebackend_helper"
import {getHireDecisionListSuccess , getHireDecisionListFail} from './actions'

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

function* getHireDecisionListHandler({payload: {json}}){
  let url = constClass.REST_API_HIRE_DECISION_LIST+`?page=${json.pageNumber}&pageSize=${json.pageSize}`
   let extentedUrl= ""
  if(json.sort !== undefined && json.Sort !== null){
       url = url+json.sort
  }
  if(json.keyword !== undefined && json.keyword  !== null && json.keyword  !== "" ){
    url = url+json.keyword
}
if(json.filter !== undefined && json.filter !== null && json.filter !== "" && json.filter.length > 0){
   json.filter.map(eachObject=>{extentedUrl +=  encodeURIComponent(eachObject.filterName)+"="+encodeURIComponent(`${[eachObject.value]}`)+"&"    
  }
  )
  extentedUrl = extentedUrl.slice(0, extentedUrl.length-1)

}
  try {
    if(extentedUrl !== ""){
     url =  url+"&"+extentedUrl
    }
    let response = yield call(getInterviewCandidateList, url);
    yield put(getHireDecisionListSuccess(response))
  }

  catch (error) {
    yield put(getHireDecisionListFail(error))
  }
}




function* HireDecisionHandleSaga() {
  yield takeEvery( GET_HIRE_DECISION_LIST, getHireDecisionListHandler)
}
export default HireDecisionHandleSaga

